'use strict'
import { serverApi } from '@/server';

export default {

    /**
     * 获取通道下的协议模板
     *
     * @author nick
     *
     * @method GET
     *
     * @param {string} chanId
     *
     * @url /api/proto-list/{$chanID}
     *
     * @returns {Promise}
     */
    getProtoByChannel(chanId) {
        const url = `/proto-list/${chanId}`
        return serverApi.get({}, url)
    },
    /**
     * 地址信息，查看
     */
    realAddress(id) {
      const url = `/individual-show-address/${id}`

      return serverApi.get({}, url);
    },
    /**
     * 批量导出并签约
     *
     *
     * @author nick
     *
     * @param {string} fileId
     * @param {object} formData
     *
     * @returns {Promise}
     */
    mutiSign(fileId, formData) {
        const url = `/sign-records/${fileId}/import`
        return serverApi.put(formData, url)
    },

    /**
     * 获取签约列表
     *
     * @method GET
     *
     * @url /api/bank-account
     *
     * @param {Object } searchData
     *
     * @returns {Promise}
     */
    getSignList(searchData = {}) {
        const url = "/sign-records"
        return serverApi.get(searchData, url)
    },
    /**
     * 签约明细-发送签约提醒短信 众包
     *
     * @author nick
     *
     * @url /spa/agreements/send/phones/sms
     *
     * @param {*} id
     *
     * @returns {Promise}
     */
    remind(formData) {
        const url = `/agreements/send/phones/sms`
        return serverApi.post(formData, url)
    },

    /**
     * 签约明细-撤回签约  众包
     *
     * @author nick
     *
     * @url /spa/agreements/recall/sign/{id}
     *
     * @param {*} id
     *
     * @returns {Promise}
     */
    backSign(ids) {
        const url = `/agreements/recall/sign`
        return serverApi.post(ids, url)
    },

    /**
     * 签约明细-解除协议 众包
     *
     * @author nick
     *
     * @url /spa/agreements/remove/sign/{id}
     *
     * @param {*} id
     * @param {Object} formData
     *
     * @returns {Promise}
     */
    removeSign(id, formData) {
        const url = `/agreements/remove/sign/${id}`
        return serverApi.get(formData, url)
    },
    /**
     * 签约明细-详情 众包
     *
     * @author nick
     *
     * @url /spa/agreements/{id}
     *
     * @param {*} id
     *
     * @returns {Promise}
     */
    signDetail(id) {
        const url = `/agreements/${id}`
        return serverApi.get({}, url)
    },

    /**
     * 个体信息列表
     *
     * @author nick
     *
     * @url /api/individuals
     *
     * @param {*} id
     *
     * @returns {Promise}
     */
    getIndividualsList(searchData = {}) {
        const url = `/individuals`
        return serverApi.get(searchData, url)
    },
    /**
     * 修改手机号
     *
     * @author nick
     *
     * @url /api/individuals/{id}
     *
     * @param {*} id
     * @param {*} phone
     *
     * @returns {Promise}
     */
    editPhone(id, phone) {
        const url = `/individuals/${id}`
        return serverApi.put({ phone }, url)
    },
    /**
     * 更改个体的是否禁用签约状态
     *
     * @author nick
     *
     * @param {*} id
     * @param {*} state
     *
     * @returns {Promise}
     */
    changeForbiddenState(id, state) {
        const url = `/individuals/${id}/forbidden`
        return serverApi.put({ is_forbidden: state }, url)
    },
    /**
     * 个体单个签约通道
     *
     * @author nick
     *
     * @param {*} formData
     *
     * @returns {Promise}
     */
    signForPersion(formData) {
        const url = `/sign-records`
        return serverApi.post(formData, url)
    },
    /**
     * 签约批次-单个发起签约
     *
     * @author nick
     *
     * @param {*} formData
     *
     * @returns {Promise}
     */
    individualSignBatches(formData) {
        const url = `/individual-sign-batches`
        return serverApi.post(formData, url)
    },


    /**
   * 获取个体信息详情
   *
   * @author wang & 2019-7-4 14:54:51
   *
   * @method GET
   *
   * @url: /api/individuals/1
   */
    getIndividualsInfo(id) {
        const url = `/individuals/${id}`

        return serverApi.get({}, url);
    },
    /**
     * 获取个体信息详情 - 签约信息列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method GET
     *
     * @url: /api/sign-record/individual/3
     */
    getSignRecordIndividual(formData, id) {
        const url = `/sign-record/individual/${id}`

        return serverApi.get(formData, url);
    },
    /**
     * 获取个体信息详情 - 银行卡列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method GET
     *
     * @url: /api/individuals/banks/ 120732199810241234
     */
    getIndividualAccountsList(id,formData) {
        const url = `/individuals/banks/${id}`

        return serverApi.get(formData, url);
    },
    /**
     * 个体信息详情-支付宝/微信
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method GET
     *
     * @url: /api/individuals/banks/ 120732199810241234
     */
    getIndividualNotBanks(id) {
        const url = `/individuals/notbanks/${id}`

        return serverApi.get({}, url);
    },
    /**
     * 个人账户查看
     * @author zhang
     *
     * @method GET
     */
    individualShowAccounts(id,formData) {
        const url = `/individual-show-account/${id}`

        return serverApi.get(formData, url);
    },

    /**
       * 下载签约通道的合同协议
       *
       * @author nick
       *
       * @param {*} formData
       * @param {*} fileName
       *
       * @returns {Blob}
       */
    downLoad(formData, fileName) {
        const url = `/download-sign-channels`
        return serverApi.downLoadByPost(formData, url, fileName);

    },
    /**
     * 下载签约模板
     */
    downloadTemplate(formData, name) {
        const url = `/download/sign-records`
        return serverApi.downLoadByPost(formData, url, name ? name : '签约模板-v1.0.xlsx');
    },
    /**
     * 下载批量签约导入的失败数据
     */
    downloadImportFaild(formData) {
        const url = `/sign-records/fail-down`
        return serverApi.downLoadByPost(formData, url, '导入失败.xlsx');
    },
    /**
     * 审核身份证文件预览
     *
     * @author nick
     *
     * @param {Number} id
     *
     *
     * @returns {Promise}
     *
     */
    individualsAuditFile(id) {
        const url = `/individuals-audit-file/${id}`
        return serverApi.post({}, url);
    },
    /**
     * 审核视频预览
     *
     * @author nick
     *
     * @param {Number} id
     *
     *
     * @returns {Promise}
     *
     */
    individualsAuditVideo(id) {
        const url = `/individuals-audit-file/${id}`

        return serverApi.post({}, url);
    },


    //-------众包二期签约管理接口--------

    /**
     * 签约明细-列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method GET
     *
     * @url: /spa/agreements
     */
    getSignDetailsList(formData) {
        const url = `/agreements`

        return serverApi.get(formData, url);
    },
    /**
     * 签约明细-获取手机号/身份证
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method POST
     *
     * @url: /spa/agreements/idcard/or/phone
     */
    agreementsIdcardOrPhone(formData) {
        const url = `/agreements/idcard/or/phone`

        return serverApi.post(formData, url);
    },
    /**
     * 签约批次-列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method GET
     *
     * @url: /spa/sign-batches
     */
    getSignBatchesList(formData) {
        const url = `/sign-batches`
        return serverApi.get(formData, url);
    },
    /**
     * 签约明细导出
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method GET
     *
     * @url: /spa/agreement/excel/exports
     */
    agreementExcelExports(formData) {
        const url = `/agreement/excel/exports`
        return serverApi.get(formData, url);
    },
    /**
     * 签约明细-详情
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method GET
     *
     * @url: /spa/agreement/{id}
     */
    getAgreementDetail(formData) {
        const url = `/agreement/${id}`
        return serverApi.get(formData, url);
    },
    /**
     * 个体信息--身份证号脱敏查看
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method GET
     *
     * @url: /spa/individual-show-idcard/{id}
     */
    individualShowIdcard(id) {
        const url = `/individual-show-idcard/${id}`
        return serverApi.get({}, url);
    },
    /**
     * 个体信息--手机号脱敏查看
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method GET
     *
     * @url: /spa/individual-show-phone/{id}
     */
    individualShowPhone(id) {
        const url = `/individual-show-phone/${id}`
        return serverApi.get({}, url);
    },
    /**
     * 签约明细协议预览
     *
     * @author nick
     *
     * @method POST
     *
     * @url: /spa/contract-preview
     */
    previewContract(formData) {
        let url = `/contract-preview`;
        return serverApi.post(formData, url);
    },

    //------------- 批量导入签约-------------

    /**
     * 签约批次-上传核验签约数据
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method POST
     *
     * @url: /spa/import-sign-batches
     */
    importSignBatches(formData) {
        const url = `/import-sign-batches`
        return serverApi.post(formData, url);
    },
    /**
     * 签约批次-导入签约-获取当前待处理的签约批次信息
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method GET
     *
     * @url: /spa/unprocessed-sign-batches
     */
    unprocessedSignBatches(formData) {
        const url = `/unprocessed-sign-batches`
        return serverApi.get(formData, url);
    },
    /**
     * 签约批次-导入签约-获取核验进度
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method POST
     *
     * @url: /spa/sign-batches/bar/{batchId}
     */
    signBatchesBar(batchId) {
        const url = `/sign-batches/bar/${batchId}`
        return serverApi.post({}, url);
    },
    /**
     * 签约批次=导入签约-重新上传/取消当前签约批次
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method POST
     *
     * @url: /spa/recall-sign-batches
     */
    recallSignBatches(formData) {
        const url = `/recall-sign-batches`
        return serverApi.post(formData, url);
    },
    /**
     * 签约批次-导入签约-核验结果列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method GET
     *
     * @url: /spa/sign-caches
     */
    signCachesList(formData) {
        const url = `/sign-caches`
        return serverApi.get(formData, url);
    },
    /**
     * 签约批次-导入签约-核验结果统计
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method GET
     *
     * @url: /spa/sign-caches/{batch_id}
     */
    signCachesAmount(batch_id) {
        const url = `/sign-caches/${batch_id}`
        return serverApi.get({}, url);
    },
    /**
     * 签约批次-批量签约提交签约
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method POST
     *
     * @url: /spa/submit-sign-batches
     */
    submitSignBatches(formData) {
        const url = `/submit-sign-batches`
        return serverApi.post(formData, url);
    },
    /**
     * 签约批次-获取二次核验进度
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @author nick
     *
     * @method POST
     *
     * @url: /spa/sign-batches/double-check-bar/{batchNo}}
     */
    signBatchesDoubleCheckBar(batchNo) {
        const url = `/sign-batches/double-check-bar/${batchNo}`
        return serverApi.post({}, url);
    },
    /**
     * 签约批次-导入签约-未通过数据下载
     *
     * @author nick
     *
     * @method POST
     *
     * @param {Object} formData
     * @url /spa/unpass-output-sign-batches
     *
     * @returns {Promise}
     */
    unpassOutputSignBatches(formData) {
        const url = `/unpass-output-sign-batches`
        return serverApi.downLoadByPost(formData, url, '未通过数据.xlsx');
    },
    /**
     * 签约批次-导入签约-删除数据下载
     *
     * @author nick
     *
     * @method POST
     *
     * @param {Object} formData
     * @url /spa/detele-output-sign-batches
     *
     * @returns {Promise}
     */
    deteleOutputSignBatches(formData) {
        const url = `/detele-output-sign-batches`
        return serverApi.downLoadByPost(formData, url, '已删除数据.xlsx');
    },
    /**
     * 签约批次-导入签约-失败数据下载
     *
     * @author nick
     *
     * @method POST
     *
     * @param {Object} formData
     * @url /spa/fail-output-sign-batches
     *
     * @returns {Promise}
     */
    failOutputSignBatches(formData) {
        const url = `/fail-output-sign-batches`
        return serverApi.downLoadByPost(formData, url, '失败数据.xlsx');
    },
    /**
     * 个体信息详情营业执照列表
     *
     * @author nick
     *
     * @method GET
     *
     * @param {Number} idCard
     * @url individual-business-licenses/{idCard}
     *
     * @returns {Promise}
     */
    individualBusinessLicense(formData, idCard) {
        const url = `individual-business-licenses/${idCard}`
        return serverApi.get(formData, url);
    },
    /**
     * 批量签约-未通过列表下-签约短信提醒
     *
     * @author nick
     *
     * @method POST
     *
     * @url /sign-batches-unpass-sms
     *
     * @returns {Promise}
     */
    signBatchesUnpassSms(formData) {
        const url = `/sign-batches-unpass-sms`
        return serverApi.post(formData, url);
    },
    /**
     * 签约批次待签约提醒签约
     *
     * @author nick
     *
     * @method POST
     *
     * @url /sign-batches-sms
     *
     * @returns {Promise}
     */
    signBatchesSms(formData) {
        const url = `/sign-batches-sms`
        return serverApi.post(formData, url);
    },
    /**
     * 签约模板预览
     *
     * @author nick
     *
     * @method POST
     *
     * @url /sign-batches-sms
     *
     * @returns {Promise}
     */
    previewPDF(formData) {
        const url = `/contract-preview`;
        return serverApi.post(formData, url)
    },
    /**
     * 签约批次-导入签约-重新核验
     *
     * @author nick
     *
     * @method POST
     *
     * @url /sign-batche/re-check/${batchNo}
     *
     * @returns {Promise}
     */
    signBatcheReCheck(batchNo) {
        const url = `/sign-batche/re-check/${batchNo}`;
        return serverApi.post({}, url)
    },
    /**
     * 删除签约
     *
     * @author nick
     *
     * @method POST
     *
     * @url /agreements/delete/sign
     *
     * @returns {Promise}
     */
    agreementsDeleteSign(formData) {
        const url = `/agreements/delete/sign`;
        return serverApi.post(formData, url)
    },
    /**
    * 获取签约二维码
    *
    * @author nick
    *
    *
    * @returns {Promise}
    *
    */
    agreementSignQcode(formData={}) {
        const url = `/agreement-sign-qcode`

        return serverApi.preview(formData, url, { responseType: 'blob' })
    },
    /**
     * 保存邀请码
     *
     * @author nick
     *
     * @method POST
     *
     * @returns {Promise}
     */
    agreementSignQcodeDownLoad(formData={}) {
        const url = `/agreement-sign-qcode`

        return serverApi.downLoadByPost(formData, url, '签约邀请码.png');
    },
    /**
     * 获取签约短链接
     *
     * @author nick
     *
     * @method GET
     *
     * @url /short-redirect
     *
     * @returns {Promise}
     */
    agreementShortUrl(formData) {
        const url = `/agreement-short-url`;
        return serverApi.get(formData, url)
    },
    /**
     * 签约明细协议下载
     *
     * @author nick
     *
     * @method POST
     *
     * @url: /spa/contract-download
     */
    downloadContract(formData, fileName) {
        let url = `/contract-download`;
        return serverApi.downLoadByPost(formData, url, fileName);

    },

}
